import { PiPlusBold } from "react-icons/pi"

import "./styles.scss"
import { Popover } from "@headlessui/react"
import { useRef } from "react"
import { InfoTooltip } from "../Tooltip"

export const ActionsMenu = ({ options, isDisabled = false, messageActionButton = "Ações disponíveis" }) => {
  const buttonRef = useRef(null)

  const handleClick = (item) => {
    item?.onClick()
    buttonRef?.current?.click()
  }

  return (
    <>
      <div className="dropdown-menu-select">
        <Popover>
          <Popover.Button className="dropdown-menu-select__button" ref={buttonRef} disabled={isDisabled}>
            <>
              <InfoTooltip
                info={messageActionButton}
                trigger="hover"
                children={<PiPlusBold size={16} color="#99AA99" />}
              />
            </>
          </Popover.Button>
          <Popover.Panel className="dropdown-menu-select__popover">
            <div className="dropdown-menu-select__popover-content custom-popover-content">
              <ul className="menu-list">
                {options.map((item, index) => (
                  <li className="menu-list__item" key={index} onClick={() => handleClick(item)}>
                    {item.label}
                  </li>
                ))}
              </ul>
            </div>
          </Popover.Panel>
        </Popover>
      </div>
    </>
  )
}
